import { WaTableSkeleton } from "../../../../pages/whatsapp/components/skeletons/WhatsAppPageSkeletons";

/** @deprecated Prefer BillingSkeleton / WaTableSkeleton — kept for history tab embeds */
export const PageLoadingState = () => <WaTableSkeleton rows={5} cols={4} />;
